import { useTheme } from '../../providers/GigerProvider/useTheme.js';
import { useEffect, useCallback } from 'react';
import t, { useToaster, resolveValue } from 'react-hot-toast';
import { getToasterStyles, getToastWrapperStyles } from './ToasterStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const DEFAULT_TOAST_DURATION = 8000;
function Toaster(_ref) {
  let {
    position = 'bottom-left',
    maxToasts = 2,
    ...toastOptions
  } = _ref;
  const {
    toasts,
    handlers
  } = useToaster({
    ariaProps: {
      role: 'status',
      'aria-live': 'polite'
    },
    duration: DEFAULT_TOAST_DURATION,
    ...toastOptions
  });
  const {
    startPause,
    endPause,
    calculateOffset,
    updateHeight
  } = handlers;
  useEffect(() => {
    // Removes all toasts over maxToasts number
    toasts.filter(t => t.visible).filter((_, i) => i >= maxToasts).forEach(t$1 => t.remove(t$1.id));
  }, [maxToasts, toasts]);
  return jsx("div", {
    css: getToasterStyles,
    onMouseEnter: startPause,
    onMouseLeave: endPause,
    children: toasts.map(toast => jsx(ToastWrapper, {
      toast: toast,
      position: position,
      calculateOffset: calculateOffset,
      updateHeight: updateHeight
    }, toast.id))
  });
}
function ToastWrapper(_ref2) {
  let {
    toast,
    position,
    calculateOffset,
    updateHeight
  } = _ref2;
  const theme = useTheme();
  const toastPosition = toast.position || position;
  const offset = calculateOffset(toast, {
    reverseOrder: false,
    gutter: theme.spacing(2),
    defaultPosition: position
  });
  const ref = useCallback(el => {
    if (el && !toast.height && typeof toast.height !== 'number') {
      setTimeout(() => {
        const boundingRect = el.getBoundingClientRect();
        updateHeight(toast.id, boundingRect.height);
      });
    }
  }, [toast.height, toast.id, updateHeight]);
  return jsx("div", {
    ref: ref,
    css: getToastWrapperStyles(toastPosition, offset, toast.visible),
    ...toast.ariaProps,
    children: resolveValue(toast.message, toast)
  }, toast.id);
}

export { Toaster };
//# sourceMappingURL=Toaster.js.map
